"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulingShiftType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var SchedulingShiftType_Factory = /** @class */ (function () {
    function SchedulingShiftType_Factory() {
    }
    SchedulingShiftType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Color: model.Color,
            CreatedBy: model.CreatedBy,
            CreatedByUser: User_1.User_Factory.CreateIncoming(model.CreatedByUser),
            Description: model.Description,
            EditHistory: model.EditHistory,
            EndTime: model.EndTime,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ShiftName: model.ShiftName,
            StartTime: model.StartTime,
        };
        return result;
    };
    SchedulingShiftType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Color: model.Color,
            CreatedBy: model.CreatedBy,
            CreatedByUser: User_1.User_Factory.CreateOutgoing(model.CreatedByUser),
            Description: model.Description,
            EditHistory: model.EditHistory,
            EndTime: model.EndTime,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ShiftName: model.ShiftName,
            StartTime: model.StartTime,
        };
        return result;
    };
    return SchedulingShiftType_Factory;
}());
exports.SchedulingShiftType_Factory = SchedulingShiftType_Factory;
